/* Autodetect vertical position of react-calendar-timeline and provide stickyOffset
according to it.

!Important notice #1: This HOC works fine only with static DOM structure. If some
script can change verical position of the calendar at the page you should
rework it and somehow start to listen DOM change events.

!Important notice #2: This HOC works fine only with single calendar at a page.
If there are few calendars at a page you should rework it to find element .rct-outer
of current calendar.
*/
import React, { Component } from "react"

export default BaseComponent =>
  class AutoStickyOffset extends Component {
    constructor(props) {
      super(props)

      this.calculateRequired = false

      this.state = {
        stickyOffset: 0,
      }
    }

    componentDidMount() {
      this.recalc()
    }

    recalc() {
      this.calculateRequired = false
      const rctOuter = document.querySelector(`.rct-outer`)
      const offsetTop = rctOuter.getBoundingClientRect().top - 56 // header height
      this.setState({
        stickyOffset: offsetTop,
      })
    }

    render() {
      return <BaseComponent {...this.props} {...this.state} />
    }
  }
